import React, { useEffect, useState } from 'react';
import { Card, List, Tag, message } from 'antd';
import { listPosts } from '../api/posts';
import { usePermissions } from '../../../hooks/usePermissions';

const statusColor = (s) => ({
  published: 'green',
  scheduled: 'blue',
  failed: 'red',
  draft: 'default',
}[s] || 'default');

const ContentCalendarPage = () => {
  const { canViewField } = usePermissions();
  const canViewContent = canViewField('smm', 'content');
  const canViewPlatforms = canViewField('smm', 'platforms');
  const canViewSchedule = canViewField('smm', 'scheduledTime');

  const [items, setItems] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    listPosts({}).then(res => setItems(res.data || [])).catch(() => messageApi.error('Failed to load posts'));
  }, []);

  return (
    <div className="container-fluid" style={{ padding: 24 }}>
      {contextHolder}
      <Card title="Content Calendar (simplified)">
        <List
          dataSource={items}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={canViewSchedule ? <span>{new Date(item.scheduledTime || item.createdAt).toLocaleString()} <Tag color={statusColor(item.status)}>{item.status}</Tag></span> : <Tag color={statusColor(item.status)}>{item.status}</Tag>}
                description={<div>
                  {canViewPlatforms && <div><b>Platforms:</b> {(item.platforms || []).join(', ')}</div>}
                  {canViewContent && <div style={{ whiteSpace: 'pre-wrap' }}>{item.content}</div>}
                </div>}
              />
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default ContentCalendarPage;
